import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";
import { makeStyles, createStyles, Grid } from "@material-ui/core";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 75,
        },
        secondFormControlLabelStyle: {
            marginRight: 75,
        },
    }),
);

export const NewConnectionRoofTypesForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const { values, setValues } = useFormModel<ChangeNames.NEW_CONNECTION_ROOF_TYPES>();

    const convertValue = (): string => {
        if (values.newConnectionRoofTypes.value.flat) return "flat";
        if (values.newConnectionRoofTypes.value.metal) return "metal";
        if (values.newConnectionRoofTypes.value.other) return "other";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Art des Daches
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.newConnectionRoofTypes.value = {
                                    flat: v.indexOf("flat") >= 0,
                                    metal: v.indexOf("metal") >= 0,
                                    other: v.indexOf("other") >= 0,
                                };
                            });
                        }}
                    >
                        <Grid container spacing={7} className={formControlStyles.container}>
                            <Grid item xs={7} sm={12} md={12}>
                                <FormControlLabel
                                    value="flat"
                                    className={formControlStyles.firstFormControlLabelStyle}
                                    control={<Radio />}
                                    label="Flachdach"
                                    error={values.newConnectionRoofTypes.error !== null}
                                />
                                <FormControlLabel
                                    value="metal"
                                    className={formControlStyles.secondFormControlLabelStyle}
                                    control={<Radio />}
                                    label="Metalldach"
                                    error={values.newConnectionRoofTypes.error !== null}
                                />
                                <FormControlLabel
                                    value="other"
                                    control={<Radio />}
                                    label="anderes Dach"
                                    error={values.newConnectionRoofTypes.error !== null}
                                />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
